class BilletErrorService {
  static display({ code = null, message = null } = {}) {
    if (!code && !message) {
      return null;
    }
    return {
      code,
      message
    };
  }
}

module.exports = BilletErrorService;
